import { createContext, useContext } from 'react';
const RenderTrackingContext = createContext(null);
export const RenderTrackingProvider = RenderTrackingContext.Provider;
/**
 * Track a render event. No-op when no RenderTrackingProvider ancestor exists.
 *
 * Overhead without provider: single useContext call returning null + branch.
 * Activate by wrapping a tree in <RenderTrackingProvider value={tracker}>.
 */
export function useTrackRender(label) {
    const tracker = useContext(RenderTrackingContext);
    if (tracker) {
        tracker.track(label);
    }
}
//# sourceMappingURL=TemplateDebugContext.js.map